import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FacetsPage } from 'src/app/facets/facets-page/facets-page.component';
import { UserAuthoritiesService } from 'src/app/services/user-authorities.service';
import { triggerAnalyticsEvent } from 'src/app/utils/analytics/trigger-analytics';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { SAAS_ONLY_FEATURE_TOOL_TIP } from 'src/app/constants/tooltips';
import { replaceUnderScore } from '../../utils/array-utils';

declare var gtag;

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent extends FacetsPage implements OnChanges {
  @Input()
  heading: string;

  @Input() pageHeadingTextAsLink: {
    link: string;
    openInNewTab: boolean;
    tooltip?: string;
  };

  @Input()
  analyticsData: any;
  @Input()
  analyticsPrefix: string;

  @Input()
  subheading: string;

  @Input()
  headingIconTooltip: string;

  @Input()
  onBack: () => {};

  @Input()
  isTabHeader: boolean = false;

  @Input()
  buttonClass = '';

  @Input()
  headingIconClass = '';

  @Input() actionButtons: {
    id: string;
    title: string;
    buttonType: string;
    nbTooltip: string;
    icon: any;
    disabled: boolean;
    hidden: boolean;
    loading?: boolean;
    gtagEvent: {
      action: string;
      category: string;
    };
    action: string;
    actionsList?: string[];
    dataAttrActionId?: string;
    disabledForSaaS: boolean;
  }[] = [];

  tertiaryButtons: {
    id: string;
    title: string;
    buttonType: string;
    nbTooltip: string;
    icon: any;
    disabled: boolean;
    hidden: boolean;
    loading?: boolean;
    gtagEvent: {
      action: string;
      category: string;
    };
    action: string | string[];
    actionsList?: string[];
    buttonSuffixIconProps: {
      icon: string;
      status: string;
    };
    dataAttrActionId?: string;
  }[] = [];

  clusterId: string;

  readonly SAAS_ONLY_FEATURE_TOOL_TIP = SAAS_ONLY_FEATURE_TOOL_TIP;

  @Input() headingIcons: {
    id: string;
    icon: string;
    pack: string;
    status: string;
    iconSize: string;
    class: string;
    iconTooltip: string;
  }[] = [];

  @Input() primaryIcon: {
    id: string;
    icon: string;
    img?: string;
    pack: string;
    status: string;
    iconTooltip: string;
    iconSize: string;
    headerIcon?: string;
  };
  @Input() showHighlighterForMoreActions: boolean = false;
  @Input() statusProp: string;
  @Input() editResourceCenter;
  @Input() vcsDetails: any;
  @Input() showPrimaryIcon: boolean = false;

  titleIconName: string;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter<string>();

  @Output() tertiaryButtonSuffixIconClick = new EventEmitter<string>();
  private backUrl: any[] = undefined;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public userAuthoritiesService: UserAuthoritiesService,
    public featureFlagService: FeatureFlagsService,
  ) {
    super(activatedRoute);
  }

  OnPageLoad(p: Params): void {
    if (p) {
      this.clusterId = p?.clusterId;
    }
    this.route.queryParams.subscribe((qp) => {
      if (qp?.backUrl) {
        this.backUrl = [qp?.backUrl];
      }
    });
    this.titleIconName = replaceUnderScore(this.primaryIcon?.id);
  }

  ngOnChanges(change: SimpleChanges) {
    if (change.actionButtons?.currentValue) {
      const actionButtons = change.actionButtons.currentValue;
      this.tertiaryButtons = actionButtons.filter((button) => {
        return button.buttonType === 'tertiary';
      });
    }
  }

  onButtonClick(value: any) {
    if (value.gtagEvent) {
      this.trackOnClick(value.gtagEvent);
    }
    this.click.emit(value.id);
    if (this.analyticsPrefix) {
      triggerAnalyticsEvent(
        `${this.analyticsPrefix}_${value?.id?.toUpperCase()}`,
        this.analyticsData,
      );
    }
  }

  trackOnClick(gtagEventObject) {
    gtag('event', gtagEventObject.action, {
      eventCategory: gtagEventObject.category,
    });
  }

  onClickSuffixIcon(button) {
    this.tertiaryButtonSuffixIconClick?.emit(button?.id);
  }

  onBackClick() {
    if (this.backUrl) {
      this.router.navigate(this.backUrl);
    } else if (this.onBack) {
      this.onBack();
    }
    if (this.analyticsPrefix) {
      triggerAnalyticsEvent(`${this.analyticsPrefix}_BACK`);
    }
  }

  onClickHandleOption() {
    if (this.analyticsPrefix) {
      triggerAnalyticsEvent(`${this.analyticsPrefix}_OPTIONS`);
    }
  }
}
